import $ from 'jquery';
import 'slick-carousel';

const HeroSlider = () => {
  const heroCarousel = $('.hero__image');

  heroCarousel.slick({
    lazyLoad: 'ondemand',
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    speed: 2000,
    fade: true,
    cssEase: 'ease-in-out',
    touchThreshold: 100,
    draggable: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    swipe: false,
    touchMove: false,
    arrows: false,
    zIndex: 10,
  });
};

export default HeroSlider;
